import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    avatarWrapper: {
        display: "flex",
        gap: theme.spacing(4),
    },
    nameAndDateWrapper: {
        display: "flex",
        flexDirection: "column",
    },
    avatarName: {
        fontFamily: "Open Sans",
        fontWeight: 700,
        fontSize: "14px",
    },
    avatarDate: {
        fontFamily: "Open Sans",
        fontWeight: 400,
        fontSize: "11px",
    },
    observationText: {
        fontFamily: "Open Sans",
        fontWeight: 400,
        fontSize: "14px",
        marginTop: theme.spacing(2),
    },
}));
